<template>
  <div>
    <v-container v-if="value.title || value.paragraph">
      <TitleParagraphRow :value="value" />

      <v-row>
        <v-col>
          <v-divider style="opacity: 0.5" />
        </v-col>
      </v-row>
    </v-container>

    <v-container v-if="value.items && value.items.length">
      <v-row v-for="item in value.items" :key="item.id" dense>
        <v-col cols="12">
          <VerticalStoryItem :value="item" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
